import { Swiper, Navigation } from 'swiper';
import focusLock from 'dom-focus-lock';
import { getBreakpoints } from '../utils/utils';

const header = () => document.querySelector('.header');
const { md } = getBreakpoints();

let floorPlansSwiper = null;
let shouldShowFocusRing = false;

document.addEventListener('keydown', (event) => {
  if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
    shouldShowFocusRing = true;
  }
}, true);

document.addEventListener('mousedown', () => {
  shouldShowFocusRing = false;
}, true);

const isModalOpen = () => {
  const modal = document.getElementById('floorPlansModal');
  return modal && getComputedStyle(modal).display !== 'none';
};

const isMobileViewport = () => window.innerWidth < md;

function syncHeaderZIndex() {
  const el = header();
  if (!el) {
    return;
  }

  if (isModalOpen() && isMobileViewport()) {
    el.style.setProperty('z-index', '2');
  } else {
    el.style.removeProperty('z-index');
  }
}

function initSwiper() {
  if (floorPlansSwiper) {
    floorPlansSwiper.destroy(true, true);
  }

  floorPlansSwiper = new Swiper('.floor-plans-dialog__slider', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
      nextEl: '.floor-plans-dialog__arrow--next .floor-plans-dialog__arrow-btn',
      prevEl: '.floor-plans-dialog__arrow--prev .floor-plans-dialog__arrow-btn',
    },
  });
}

function openModal(templateId) {
  const wrapper = document.getElementById('floorPlansSliderWrapper');
  if (!wrapper) return;

  wrapper.innerHTML = '';

  // Get floor plans from template
  const template = document.querySelector(templateId);
  if (!template) return;

  const slides = template.content.cloneNode(true);
  const slideElements = slides.querySelectorAll('.swiper-slide');

  if (!slideElements.length) return;

  const isSingleImage = slideElements.length === 1;
  const modal = document.getElementById('floorPlansModal');
  const arrows = modal?.querySelectorAll('.floor-plans-dialog__arrow');

  // Append slides to wrapper
  slideElements.forEach((slide) => {
    wrapper.appendChild(slide.cloneNode(true));
  });

  // Hide/show arrows based on number of images
  if (isSingleImage) {
    arrows?.forEach((arrow) => {
      const arrowElement = arrow;
      arrowElement.style.display = 'none';
    });
  } else {
    arrows?.forEach((arrow) => {
      const arrowElement = arrow;
      arrowElement.style.display = 'flex';
    });
  }

  modal.style.display = 'flex';
  document.getElementById('floorPlansOverlay').style.display = 'block';
  document.body.classList.add('overflow-hidden');
  document.body.classList.add('floor-plans-open');

  // Enable focus trap
  focusLock.on(modal);

  syncHeaderZIndex();

  setTimeout(() => {
    // Only init Swiper if there's more than 1 image
    if (!isSingleImage) {
      initSwiper();
    }

    if (shouldShowFocusRing) {
      document.querySelector('.floor-plans-dialog__button')?.focus();
    }
  }, 100);
}

function closeModal() {
  const modal = document.getElementById('floorPlansModal');

  // Disable focus trap
  focusLock.off(modal);

  modal.style.display = 'none';
  document.getElementById('floorPlansOverlay').style.display = 'none';
  document.body.classList.remove('overflow-hidden');
  document.body.classList.remove('floor-plans-open');

  if (floorPlansSwiper) {
    floorPlansSwiper.destroy(true, true);
    floorPlansSwiper = null;
  }

  syncHeaderZIndex();
}

let wasMobile = isMobileViewport();

window.addEventListener('resize', () => {
  const mobile = isMobileViewport();
  if (mobile === wasMobile) {
    return;
  }
  wasMobile = mobile;
  syncHeaderZIndex();
});

function bindFloorPlansTrigger(trigger) {
  const openFromTrigger = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const templateId = trigger.getAttribute('data-floor-plans-target');
    if (templateId) {
      openModal(templateId);
    }
  };

  trigger.addEventListener('click', openFromTrigger);
  trigger.addEventListener('keydown', (event) => {
    if (trigger.tagName === 'A' && (event.key === ' ' || event.key === 'Spacebar')) {
      openFromTrigger(event);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const floorPlansDialog = document?.querySelector('#floorPlansModal');
  if (floorPlansDialog) {
    const floorPlansTriggers = '.c-button--floor-plans';
    const floorPlansCloseBtn = '.floor-plans-dialog__button';

    document.querySelectorAll(floorPlansTriggers).forEach((trigger) => {
      bindFloorPlansTrigger(trigger);
    });

    document.querySelector(floorPlansCloseBtn)?.addEventListener('click', closeModal);

    const interactiveSelector = [
      '.floor-plans-dialog__image',
      '.floor-plans-dialog__arrow-btn',
      '.floor-plans-dialog__button',
    ].join(', ');

    floorPlansDialog.addEventListener('click', (event) => {
      if (!isModalOpen()) {
        return;
      }

      if (event.target.closest(interactiveSelector)) {
        return;
      }

      closeModal();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isModalOpen()) {
        closeModal();
      }
    });
  }
});
